import gql from 'graphql-tag';

const incapacidadesRamasTableQuery = gql`
    query incapacidades_ramas($numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        incapacidades_ramas(first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                nombre
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`


const queries = { incapacidadesRamasTableQuery };

export default queries;
